(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    class CartComplementaryProducts extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const button = event.target.closest('[data-add-complementary-product]');

      if (!(button instanceof HTMLButtonElement) || button.disabled) return;

      this.addVariant(button);
    }

    async addVariant(button) {
      const variantId = button.dataset.variantId;

      if (!variantId) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = this.dataset.addingLabel || 'Adding...';

      try {
        const sectionIds = [
          ...new Set(
            Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
              .map((component) => component.dataset.sectionId)
              .filter(Boolean)
          ),
        ];

        const addResponse = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
          }),
        });

        const addResult = await addResponse.json();

        if (!addResponse.ok || addResult.status) {
          throw new Error(addResult.message || 'Error adding to cart');
        }

        const cartResponse = await fetch(this.dataset.cartUrl, {
          headers: {
            Accept: 'application/json',
          },
        });

        if (!cartResponse.ok) {
          throw new Error(`Failed to refresh cart: ${cartResponse.status}`);
        }

        const cart = await cartResponse.json();

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: `cart-complementary-products-${variantId}`,
              data: {
                source: 'cart-complementary-products',
                itemCount: cart.item_count,
                sections: addResult.sections || {},
              },
            },
          })
        );

        button.textContent = this.dataset.addedLabel || 'Added';

        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 1500);
      } catch (error) {
        console.error(error);
        button.textContent = this.dataset.errorLabel || 'Error';

        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 1800);
      }
    }
  }

  if (!customElements.get('cart-complementary-products')) {
    customElements.define('cart-complementary-products', CartComplementaryProducts);
  }
  } catch(e) { console.error(e); }
})();

})();
